import { getRequestHeaders, handleRes, logError } from "utils";
import { Branding } from "types";
import { DEFAULT_BRANDING } from "context/themeContext";

export const getBranding = async (path: string): Promise<Branding> => {
  return fetch(`${window.USER_BASE_URL}/branding/${path}`, {
    method: "GET",
    ...getRequestHeaders(),
  })
    .then((res) => handleRes<Branding>(res, 200))
    .catch((e) => {
      if (e.message.includes("branding not found")) {
        return DEFAULT_BRANDING;
      }
      logError(e);
      return DEFAULT_BRANDING;
    });
};

type IsCompanyPathAvailableParams = {
  path: string;
  tenantID: string;
};
interface IsCompanyPathAvailableResponse extends Response {
  available?: boolean;
}

export const isCompanyPathAvailable = async ({
  path,
  tenantID,
}: IsCompanyPathAvailableParams): Promise<IsCompanyPathAvailableResponse> => {
  return fetch(`${window.USER_BASE_URL}/tenant/${tenantID}/companyPath`, {
    method: "POST",
    ...getRequestHeaders(),
    body: JSON.stringify({ companyPath: path }),
  });
};
